export const ADMIN_LOGIN_URL = '/api/auth/login'
export const ADMIN_LOGOUT_URL = '/api/auth/logout'
export const ADMIN_TERMINAL_URL = '/api/terminal'
export const ADMIN_DEPARTURES_URL = '/api/terminal/departuresForNext24hours'
export const ADMIN_CLOSED_DEPARTURES_URL = '/configuration/closedDepartures'
export const ADMIN_UI_CONFIG_URL = '/configuration'
export const ADMIN_GET_PAIRS_URL = '/dictionary/pairs'
